export const TestIds = {
  content: 'footer-container-content',
} as const;

export const corvidName = '$w.Footer';
